import { UserPromiseClient } from '@trustero/trustero-api-web/lib/account/account_grpc_web_pb'
import { Empty } from 'google-protobuf/google/protobuf/empty_pb'
import { Users } from '@trustero/trustero-api-web/lib/account/account_pb'
import { useSwrImmutableGrpc } from '../useSwrImmutableGrpc'
import { GrpcResponse, NewGrpcResponse } from '../hooks/types'

export const useUsersInAccount = (): GrpcResponse<Users> => {
  const { response } = useSwrImmutableGrpc(
    UserPromiseClient.prototype.getUsersInAccount,
    new Empty(),
  )
  return NewGrpcResponse(response)
}
